const MESSAGE_TYPES = {
  KEEPALIVE: "KEEPALIVE",
  SAVE_SESSION: "SAVE_SESSION",
  COGNITO_LOGIN: "COGNITO_LOGIN",
  REFRESH_SESSION: "REFRESH_SESSION",
  SIMPLE_LOGIN: "SIMPLE_LOGIN"
};
const KEEPALIVE_INTERVAL_MS = 15 * 1e3;
let keepaliveTimerId = null;
function startKeepalive() {
  if (keepaliveTimerId) return;
  keepaliveTimerId = setInterval(() => {
    if (isServiceWorkerAvailable()) {
      console.log("Pinging SW...");
      fetch(`/__sw_heartbeat__?t=${Date.now()}`, {
        cache: "no-store",
        keepalive: true
      }).catch(() => {
      });
    }
  }, KEEPALIVE_INTERVAL_MS);
}
function stopKeepalive() {
  if (keepaliveTimerId) {
    clearInterval(keepaliveTimerId);
    keepaliveTimerId = null;
  }
}
const isServiceWorkerAvailable = () => {
  return "serviceWorker" in navigator && navigator.serviceWorker?.controller;
};
const waitForServiceWorker = () => {
  if (!("serviceWorker" in navigator) || navigator.serviceWorker === void 0) {
    return Promise.resolve(false);
  }
  if (navigator.serviceWorker?.controller) {
    return Promise.resolve(true);
  }
  if (navigator.serviceWorker.ready) {
    return navigator.serviceWorker.ready.then(() => !!navigator.serviceWorker?.controller);
  }
  return Promise.resolve(false);
};
const sendToServiceWorker = (message, transfer = void 0) => {
  if (!isServiceWorkerAvailable()) {
    return;
  }
  if (transfer) {
    navigator.serviceWorker.controller.postMessage(message, transfer);
  } else {
    navigator.serviceWorker.controller.postMessage(message);
  }
};
const RESPONSE_TIMEOUT_MS = 15e3;
const requestFromSW = (type, payload, timeoutError, defaultError) => {
  return new Promise((resolve, reject) => {
    if (!isServiceWorkerAvailable() || typeof MessageChannel === "undefined") {
      reject(new Error("Service Worker not available"));
      return;
    }
    const channel = new MessageChannel();
    const closePort = (port) => {
      if (port && typeof port.close === "function") {
        port.close();
      }
    };
    const timeoutId = setTimeout(() => {
      closePort(channel.port1);
      reject(new Error(timeoutError));
    }, RESPONSE_TIMEOUT_MS);
    if (timeoutId && typeof timeoutId.unref === "function") {
      timeoutId.unref();
    }
    channel.port1.onmessage = (event) => {
      clearTimeout(timeoutId);
      closePort(channel.port1);
      const data = event.data || {};
      if (data.success) {
        resolve({ username: data.username, access: data.access });
      } else {
        reject(new Error(data.error || defaultError));
      }
    };
    sendToServiceWorker(
      payload !== void 0 ? { type, payload } : { type },
      [channel.port2]
    );
  });
};
const authClient = {
  /** Clears all session data in the Service Worker and stops keepalive. */
  clear() {
    stopKeepalive();
    waitForServiceWorker().then((isReady) => {
      if (!isReady) return;
      sendToServiceWorker({ type: MESSAGE_TYPES.SAVE_SESSION, payload: {} });
    });
  }
};
authClient.loadFromSW = async () => {
  await waitForServiceWorker();
};
authClient.loginWithCredentials = (username, password) => {
  return requestFromSW(
    MESSAGE_TYPES.COGNITO_LOGIN,
    { username, password },
    "Service Worker did not respond to COGNITO_LOGIN",
    "Login failed"
  ).then((result) => {
    startKeepalive();
    return result;
  });
};
authClient.refreshSession = () => {
  return requestFromSW(
    MESSAGE_TYPES.REFRESH_SESSION,
    void 0,
    "Service Worker did not respond to REFRESH_SESSION",
    "Refresh failed"
  ).then((result) => {
    startKeepalive();
    return result;
  });
};
authClient.simpleLogin = (key) => {
  return requestFromSW(
    MESSAGE_TYPES.SIMPLE_LOGIN,
    { key },
    "Service Worker did not respond to SIMPLE_LOGIN",
    "Simple login failed"
  ).then((result) => {
    startKeepalive();
    return result;
  });
};
export default authClient;
